import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_ESTADO = `${modulo.GESTAO_DE_DEMANDAS}/estadosDemandas`

const actions = {
  findAll ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: URL_ESTADO
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/demandas/estados.js